import script from "./categories-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./categories-modal.vue?vue&type=script&setup=true&lang=js"

import "./categories-modal.vue?vue&type=style&index=0&id=c05dfbf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c05dfbf8"]])

export default __exports__